import { postJson, postForm } from '../config/HttpClient'
import { numeroDaApi } from '@/utils/moeda'

export interface ArtigoReservaPOS {
  nome: string
  preco: number
  id: number
  qtd: number
  desconto: number
  taxa: number
  tipo: string
  idCategoria: number
  referenciaCategoria: string
  retencao: number
}

function normalizar(artigo: ArtigoReservaPOS): ArtigoReservaPOS {
  return {
    ...artigo,
    preco: numeroDaApi(artigo.preco),
    taxa: numeroDaApi(artigo.taxa),
    qtd: numeroDaApi(artigo.qtd),
    desconto: numeroDaApi(artigo.desconto),
    retencao: numeroDaApi(artigo.retencao)
  }
}

export type AccaoArtigoTemporario = 'mais' | 'menos' | 'apagar' | 'abandonar'

export interface MutacaoResultado {
  artigos: ArtigoReservaPOS[]
  sucesso: boolean
  mensagem: string
}

class ArtigoReservaService {
  async listarArtigos(codigoReserva: string): Promise<ArtigoReservaPOS[]> {
    const artigos = await postJson<ArtigoReservaPOS[] | null>(`/api-pos/artigo-reserva/lista-artigos-reserva-pos-restaurante/${codigoReserva}`)
    return (artigos ?? []).map(normalizar)
  }

  async mutar(codigoReserva: string, accao: AccaoArtigoTemporario, produtoId?: number): Promise<MutacaoResultado> {
    const campos: Record<string, string> = { qtd: '1', desconto: '0' }
    if (produtoId != null) campos['produto.id_produto'] = String(produtoId)

    const resposta = await postForm<{ artigos?: ArtigoReservaPOS[]; tipo: string; msg: string }>(
      `/api-pos/artigo-reserva/crud-artigo-temporario/${codigoReserva}/${accao}`,
      campos
    )

    return {
      artigos: (resposta.artigos ?? []).map(normalizar),
      sucesso: resposta.tipo === 'sucesso',
      mensagem: resposta.msg
    }
  }
}

export default new ArtigoReservaService()
